<template>
  <div v-if="isMobile">
    <profile-mobile :authenticated="authenticated" @handleError="handleError" />
  </div>

  <div
    v-else
    class="background"
    :style="'background-image: url(' + Background + ')'"
  >
    <profile-desktop
      :authenticated="authenticated"
      @handleError="handleError"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';

  export default {
    name: 'Homes',

    components: {
      ProfileMobile: () => import('./ProfileMobile'),
      ProfileDesktop: () => import('./ProfileDesktop'),
    },

    props: ['isMobile', 'authenticated'],

    data: () => ({ Background }),

    computed: {},

    mounted() {},

    methods: {
      handleError: function(error) {
        this.$emit('handleError', error);
      },
    },
  };
</script>

<style scoped>
  .background {
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
